import {
  Component,
  HostListener,
  ViewChild,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  TemplateRef,
  ElementRef,
} from "@angular/core";
import { MatFormFieldModule } from "@angular/material/form-field";
import { KeyValue } from "@angular/common";
import { environment } from "../../../environments/environment";
import { MatInputModule } from "@angular/material/input";
import { CommonModule, Location } from "@angular/common";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { MatSelectModule } from "@angular/material/select";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { DataService } from "../../Services/data.service";
import { DialogService } from "../../Services/dialog.service";
import { DentalXmlService } from "../../Services/dental-xml.service";
import { FileUploadService } from "../../Services/file-upload.service";
import { MaterialService } from "../../Services/material.service";
import { TaskCrudService } from "../../Services/task-crud.service";
import { AbutmentService } from "../../Services/abutment.service";
import { ToothSelectionService } from "../../Services/tooth-selection.service";
import { MatChipInput, MatChipsModule } from "@angular/material/chips";
import { MatMenuModule } from "@angular/material/menu";
import { MatListModule } from "@angular/material/list";
import { FileDetails, FilesComponent } from "../files/files.component";
import { MatStepper, MatStepperModule } from "@angular/material/stepper";
import { MatTooltipModule } from "@angular/material/tooltip";
import { PropHComponent } from "./prop-h/prop-h.component";
import { PropPComponent } from "./prop-p/prop-p.component";
import { PropPFrameComponent } from "./prop-p-frame/prop-p-frame.component";
import { PropAComponent } from "./prop-a/prop-a.component";
import { PropCollarsComponent } from "./prop-collars/prop-collars.component";
import { PropCutbackComponent } from "./prop-cutback/prop-cutback.component";
import { PropPonticComponent } from "./prop-pontic/prop-pontic.component";
import { MatRadioModule } from "@angular/material/radio";
import { BiteTypeComponent } from "./bite-type/bite-type.component";
import { ArticulationComponent } from "./articulation/articulation.component";
import { DesignerSearchComponent } from "../designer-search/designer-search.component";
import { PropVComponent } from "./prop-v/prop-v.component";
import { MatSliderModule } from "@angular/material/slider";
import { ThreedComponent } from "./threed/threed.component";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { MatTab, MatTabGroup, MatTabsModule } from "@angular/material/tabs";
import { TaskDetailsComponent } from "../task-details/task-details.component";
import { ActivatedRoute, Router } from "@angular/router";
import { VideoDialogComponent } from "../video-dialog/video-dialog.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import Collapse from "@ng-bootstrap/ng-bootstrap";
import { QRCodeModule } from "angularx-qrcode";

import { AbutmentGingivalComponent } from "../abutment-gingival/abutment-gingival.component";
import { AbutmentEmergenceComponent } from "../abutment-emergence/abutment-emergence.component";
import { AbutmentDisplaceComponent } from "./abutment-displace/abutment-displace.component";
import { AbutmentMarginalHeightComponent } from "./abutment-marginal-height/abutment-marginal-height.component";
import { MagnifierComponent } from "../magnifier/magnifier.component";
import { response } from "express";
import { Material } from "three";
import { interval, Subscription } from "rxjs";

export type {
  MyBoolean,
  OrderDetailsNew,
  OrderDetails,
  articulationDetails,
  ToothDataNew,
  ToothData,
} from "../../models/order.models";
import {
  MyBoolean,
  OrderDetailsNew,
  OrderDetails,
  articulationDetails,
  ToothDataNew,
  ToothData,
} from "../../models/order.models";
declare const bootstrap: any;
@Component({
  selector: "app-create-task-demo",
  standalone: true,
  imports: [
    AbutmentGingivalComponent,
    AbutmentEmergenceComponent,
    TaskDetailsComponent,
    MatChipsModule,
    PropAComponent,
    PropPComponent,
    PropHComponent,
    PropPonticComponent,
    PropVComponent,
    MatTabsModule,
    ThreedComponent,
    BiteTypeComponent,
    ArticulationComponent,
    MatSliderModule,
    FilesComponent,
    ReactiveFormsModule,
    MatRadioModule,
    MatListModule,
    MatMenuModule,
    MatStepperModule,
    MatChipsModule,
    MatFormFieldModule,
    MatInputModule,
    MatInputModule,
    FormsModule,
    MatIconModule,
    MatSelectModule,
    CommonModule,
    MatButtonModule,
    MatTooltipModule,
    MatSidenavModule,
    PropCollarsComponent,
    PropCutbackComponent,
    PropPFrameComponent,
    AbutmentDisplaceComponent,
    AbutmentMarginalHeightComponent,
    MagnifierComponent,
    QRCodeModule,
  ],
  templateUrl: "./create-task-demo.component.html",
  styleUrls: [
    "./create-task-demo.component.css",
    "./create-task-demo.design-level.css",
    "./create-task-demo.designer-type.css",
    "../../../style-custom.css",
  ],
  providers: [FileUploadService, MaterialService, AbutmentService],
})
export class CreateTaskDemoComponent {
  @ViewChild("stepper") stepper!: MatStepper;
  @ViewChild("abutmentStep1", { static: false })
  abutmentStep1!: ElementRef<HTMLElement>;
  @ViewChild("abutmentStep2", { static: false })
  abutmentStep2!: ElementRef<HTMLElement>;
  @ViewChild("abutmentStep3", { static: false })
  abutmentStep3!: ElementRef<HTMLElement>;
  @ViewChild("abutmentStep4", { static: false })
  abutmentStep4!: ElementRef<HTMLElement>;
  activeTooltip = "";
  private abutmentStep1Instance?: any;
  private abutmentStep2Instance?: any;
  private abutmentStep3Instance?: any;
  private abutmentStep4Instance?: any;
  abutmentSelectedTooth: number = 0;

  allowPageLeave = false;
  apiUrl = environment.apiUrl;

  qrCodeUrl: string = "";
  showQRCode = false;
  private uploadPolling?: Subscription;
  uploadToken = "";

  showSlider: MyBoolean = { value: false };
  showSliderForArticulation: MyBoolean = { value: false };
  showSliderForToothType: MyBoolean = { value: false };
  showSliderForBiteType: MyBoolean = { value: false };

  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  thirdFormGroup: FormGroup;
  instructions: string = "";
  additionalNote: string = "";
  isAbustmentSelect: boolean = false;
  filledAbutmentTeeth: number[] = [];

  validated: boolean = false;
  defaultSelectedMaterialValue:string='';


  get abutmentTeeth(): any[] {
    return this.abutmentService.abutmentTeeth;
  }
  set abutmentTeeth(v: any[]) {
    this.abutmentService.abutmentTeeth = v;
  }
  allOptions: any;
 

  constructor(private cdr: ChangeDetectorRef,
    private router: Router, public cdRef: ChangeDetectorRef, private dialog: MatDialog,
    public dataService: DataService, private dialogService: DialogService, private location: Location, private _formBuilder: FormBuilder,
    private route: ActivatedRoute, private dentalXmlService: DentalXmlService,
    public fileUploadService: FileUploadService, public materialService: MaterialService,
    private taskCrudService: TaskCrudService,
    public abutmentService: AbutmentService,
    private toothSelectionService: ToothSelectionService,
  ) {
    this.firstFormGroup = this._formBuilder.group({});
    this.secondFormGroup = this._formBuilder.group({});
    this.thirdFormGroup = this._formBuilder.group({});
  }

  fileDetailsScan: FileDetails[] = [];
  fileDetailsImages: FileDetails[] = [];
  fileDetailsImagesContent: string[] = [];

  articulation: string = "";
  software: string = "";
  byteType: string = "";

  updateFileCounts(filesData: any) {
    this.fileDetailsScan = filesData.fileDetailsScan;
    this.fileDetailsImages = filesData.fileDetailsImages;
    this.fileDetailsImagesContent = filesData.fileDetailsImagesContent;
  }

  selectDesignerError: string = "";

  goToNextStep(): boolean {
    this.selectDesignerError = "";
    if (!this.orderDetailsNew.showAi && !this.orderDetailsNew.showHuman) {
      this.selectDesignerError = "Please select AI or Human designer.";
      return false;
    }

    this.validated = true;
    const hasFiles = this.hasAtLeastOneFile();
    if (
      this.orderDetailsNew.refNum &&
      (this.orderDetailsNew.showAi || this.orderDetailsNew.showHuman) &&
      this.orderDetailsNew.deliveryTime &&
      this.orderDetailsNew.software &&
      hasFiles &&
      (this.orderDetailsNew.showAi ||
        (this.orderDetailsNew.showHuman && this.orderDetailsNew.tier))
    ) {
      this.stepper.next();
      return true;
    }

    return false;
  }

  get getAllToothCountFromOrderDetails(): number {
    return this.orderDetailsNew.toothData.reduce((acc, data) => acc + 1, 0);
  }

  // bridges: { bridgedTeeth: number[], start: number; end: number; bridgeConnectionType: string }[] = [];

  showBridge(toothIdA: number, toothIdB: number): boolean {
    return this.toothSelectionService.showBridge(
      toothIdA,
      this.orderDetailsNew.bridges,
      this.teethList,
    );
  }

  showBridgeDot(toothId: number): boolean {
    return this.toothSelectionService.showBridgeDot(
      toothId,
      this.orderDetailsNew.toothData,
    );
  }

  showEmpty(toothId: number): boolean {
    return this.toothSelectionService.showEmpty(
      toothId,
      this.orderDetailsNew.toothData,
      this.orderDetailsNew.bridges,
      this.teethList,
    );
  }

  shiftKeyPressed: boolean = false;

  @HostListener("window:keydown", ["$event"])
  handleKeyDown(event: KeyboardEvent) {
    if (event.shiftKey) {
      this.shiftKeyPressed = true;
    }
  }

  @HostListener("window:keyup", ["$event"])
  handleKeyUp(event: KeyboardEvent) {
    if (!event.shiftKey) {
      this.shiftKeyPressed = false;
    }
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (
      target.tagName === "BUTTON" ||
      target.tagName === "INPUT" ||
      this.isXmlUpload
    ) {
      return;
    }
    const toothGroups = document.querySelector(".tooth-group");

    if (
      toothGroups &&
      !toothGroups.contains(target) &&
      !target.closest(".tooth-group") &&
      !target.closest(".dropdown") &&
      !target.closest(".accordion") &&
      !target.closest(".add-new-material")
    ) {
      this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .forEach((data) => this.onToothClick(data.teeth.toString()));
    }

    if (!target.closest(".custom-context-menu")) {
      this.showMenu = false;
    }
  }
  @HostListener("window:beforeunload", ["$event"])
  onBeforeUnload(event: BeforeUnloadEvent) {
    event.preventDefault();
    event.returnValue = ""; // Required for Chrome → triggers default popup
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event: any) {
    // if(this.allowPageLeave){
    //   return;
    //  }
    // const leave = confirm("You have unsaved changes. Do you want to leave this page?");
    // if (!leave) {
    //   history.pushState({dummy:true}, '', location.href); // Cancel browser back
    //   return;
    // }
    history.back();
    return true;
  }
  selectedStep = 0;

  onStepChange(event: StepperSelectionEvent) {
    this.selectedStep = event.selectedIndex;

    this.render3d = event.selectedIndex === 2;

    if (
      event.previouslySelectedIndex == 0 &&
      (event.selectedIndex == 1 ||
        event.selectedIndex == 2 ||
        event.selectedIndex == 3) &&
      !this.goToNextStep()
    ) {
      setTimeout(() => {
        this.stepper.selectedIndex = event.previouslySelectedIndex;
      });
    } else if (
      event.previouslySelectedIndex == 1 &&
      (event.selectedIndex == 2 || event.selectedIndex == 3) &&
      !this.validateToothSelection()
    ) {
      setTimeout(() => {
        this.stepper.selectedIndex = event.previouslySelectedIndex;
      });
    }
  }

  render3d: boolean = false;

  isHovered: any = { H: false, F: false, A: false, P: false };

  onMouseEnter(group: string): void {
    this.isHovered[group] = true;
  }

  onMouseLeave(group: string): void {
    this.isHovered[group] = false;
  }

  getTeethByComma(teeth: number[]): string {
    return Array.from(teeth)
      .sort((a, b) => a - b)
      .join(", ");
  }

  getTeethLabel(toothData: ToothData): string {
    return toothData.teeth.sort((a, b) => a - b).join("-");
  }

  get getBridgeToothData(): number[][] {
    var toothDataToReturn: number[][] = [];

    this.orderDetailsNew.bridges.forEach((bridge) => {
      var bridgeStarted = false;
      var bridgeEnded = false;
      var teethToAdd: number[] = [];
      this.teethList.forEach((teeth) => {
        if (teeth == bridge.end) {
          bridgeEnded = true;
        }

        if (bridgeStarted && !bridgeEnded) {
          teethToAdd.push(teeth);
        }

        if (teeth == bridge.start) {
          bridgeStarted = true;
        }
      });

      toothDataToReturn.push(teethToAdd);
    });

    return toothDataToReturn;

    // this.bridges.map(bridge => {
    //   var start = bridge.start;
    //   var end = bridge.end;
    //   this.orderDetailsNew.toothData.forEach(data => {
    //     if(data.teeth.includes(start) && data.teeth.includes(end)){
    //       data.bridgeConnectionType = 'Strong connection';
    //     }
    //   });
    // }
    // return this.orderDetailsNew.toothData.filter(data => data.bridgeConnectionType);
  }

  get getToothDataForVisualisation(): ToothData[] {
    var toothDataToReturn: ToothData[] = [];
    // toothDataToReturn.push(...this.getBridgeToothData);
    // toothDataToReturn.push(...this.orderDetailsNew.toothData.filter(data => !data.bridgeConnectionType && !this.getBridgeToothData.some(bts => bts.teeth == data.teeth)));
    return toothDataToReturn;
  }

  checkTwoSetIntersect(array1: number[], array2: number[]): boolean {
    return array1.some((tooth) => array2.includes(tooth));
  }

  @ViewChild("tabGroup") tabGroup!: MatTabGroup;
  @ViewChildren(MatTab) tabs!: QueryList<MatTab>;

  selectTabByLabel(tabLabel: string): void {
    const tabIndex = this.getTabIndexByLabel(tabLabel);
    if (tabIndex !== -1) {
      this.tabGroup.selectedIndex = tabIndex;
    }
  }

  private getTabIndexByLabel(tabLabel: string): number {
    const tabsArray = this.tabs.toArray();
    this.orderDetailsNew.toothData.forEach((data) => {
      if (data.teeth == Number(tabLabel) && data.type == "Bridge") {
        // tabLabel = this.getTeethLabel(data);
      }
    });

    for (let i = 0; i < tabsArray.length; i++) {
      if (tabsArray[i].ariaLabel.includes(tabLabel)) {
        return i;
      }
    }
    return -1;
  }

  openBiteTypeSelection(value: string) {
    if (value == "yes") {
      this.biteType = "normal bite";
      this.pushCurrentQuesAns({ ques: "Bite Type", ans: "normal bite" });
      return;
    }
  }

  pushCurrentQuesAns(qaNew: any) {
    var updated: boolean = false;
    this.currentQuesAns.forEach((qa) => {
      if (qa.ques == qaNew.ques) {
        qa.ans = qaNew.ans;
        updated = true;
        return;
      }
    });
    if (!updated) {
      this.currentQuesAns.push(qaNew);
    }
  }

  // getSubTypes(): string{
  //   return this.selectedSubTypes.filter(subType => this.availableSubTypes.includes(subType)).join();
  // }

  isOpen = false;
  toothData: any[] = [];
  types: any[] = [];
  subTypes: any[] = [];
  props: any[] = [];
  biteType: string = "normal bite";

  currentTeethSet: Set<number> = new Set();
  currentType: string = "";
  currentSubType: string = "";
  currentProps: any[] = [];
  currentQuesAns: any[] = [];

  selectedTeethSet: Set<number> = new Set();
  selectedTypes: string[] = [];
  selectedSubTypes: string[] = [];

  summary: string[] = [];

  availableTypes: string[] = [];
  availableSubTypes: any[] = [];

  taskId: number = 0;

  clearAll() {
    this.orderDetailsNew = {
      showHuman: this.orderDetailsNew.showHuman,
      showAi: this.orderDetailsNew.showAi,
      taskId: this.taskId,
      refNum: this.orderDetailsNew.refNum,
      tier: this.orderDetailsNew.tier,
      deliveryTime: this.orderDetailsNew.deliveryTime,
      designer: "",
      isFav: false,
      rating: 0,
      experience: 0,
      skill: "",
      software: this.orderDetailsNew.software,
      instructions: "",
      articulationDetails: {
        articulator: this.orderDetailsNew.articulationDetails.articulator,
        props: this.orderDetailsNew.articulationDetails.props,
      },
      biteType: this.orderDetailsNew.biteType,
      toothData: [],
      props: {
        "Crown wear-front": "Regular",
        "Crown wear-side": "Regular",
        undercuts: "Yes",
        "ceramic-veneering-anterior": 1.5,
        "ceramic-veneering-posterior": 1.5,
        "ceramic-veneering-bridge": 1.5,
      },
      bridges: [],
      remainingCorrections: 0,
    };
    // ✅ IMPORTANT: clear all related arrays
    this.abutmentTeeth = [];
    this.abutmentSelectedTeeth = [];
    this.submittedTeeth = [];

    // ✅ flags
    this.isAbustmentSelect = false;
    this.showMenu = false;
    this.teethType = "";
  }

  clear() {
  
    const tooth = this.rightClickedTooth;

    this.orderDetailsNew.toothData = this.orderDetailsNew.toothData.filter(
      (d) => d.teeth !== tooth,
    );

    this.abutmentTeeth = this.abutmentTeeth.filter((t) => t.teeth !== tooth);

    this.abutmentSelectedTeeth = this.abutmentSelectedTeeth.filter(
      (t) => t !== tooth,
    );

    this.submittedTeeth = this.submittedTeeth.filter((t) => t !== tooth);

    this.showMenu = false;
    this.removeToothFromBridge(tooth);
  }
  getSliderPosition(param: any): number {
    const config = this.paramConfig[param.name];
    if (!config) return 0;

    const value = param.value ?? config.min;

    return ((value - config.min) / (config.max - config.min)) * 100;
  }
  onParamNameChange(param: any) {
    const config = this.paramConfig[param.name];
    param.value = config ? config.min : "";
  }
  paramConfig: any = {
    minimalThickness: { min: 0.1, max: 1, step: 0.1 },
    cementGap: { min: 0.005, max: 0.05, step: 0.005 },
    marginGap: { min: 0.1, max: 1, step: 0.1 },
    horizontalBorder: { min: 0.005, max: 0.05, step: 0.005 },
    radiusCompensation: { min: 0.1, max: 1, step: 0.1 },
  };
  //init order details
  orderDetailsNew: OrderDetailsNew = {
    showAi: false,
    showHuman: false,
    taskId: this.taskId,
    refNum: "",
    tier: "",
    deliveryTime: "",
    designer: "",
    isFav: false,
    rating: 0,
    experience: 0,
    skill: "",
    software: "",
    instructions: "",
    articulationDetails: {
      articulator: "Artex von Amann Girrbach",
      props: {
        "Protrusion Angle": "30",
        "Bennett Angle": "15",
        "Immediate Side Shift (ISS)": "0.5",
        "Incisal Guidance": "10",
        "Raising or lowering the articulator": "-0.2",
      },
    },
    biteType: "normal bite",
    toothData: [],
    props: {
      "Crown wear-front": "Regular",
      "Crown wear-side": "Regular",
      undercuts: "Yes",
      "ceramic-veneering-anterior": 1.5,
      "ceramic-veneering-posterior": 1.5,
      "ceramic-veneering-bridge": 1.5,
    },
    bridges: [],
    remainingCorrections: 0,
  };

  currentToothData!: ToothData;

  initCurrentToothData() {
    this.currentToothData = {
      teeth: [],
      type: "",
      subType: "",
      minimalThickness: 0.5,
      cementGap: 0.015,
      marginGap: 0.5,
      horizontalBorder: 0.015,
      radiusCompensation: 0.5,
      bridgeConnectionType: "",
      props: this.props.reduce((map, prop) => {
        map[prop.name] = prop.value;
        return map;
      }, {}),
    };
  }

  clearCurrentToothSelection() {
    this.initCurrentToothData();
    this.refreshAvailableTypes();
  }

  checkToothIndexStartOrEnd(tooth: number, teeth: Set<number>): boolean {
    return (
      Math.min(...Array.from(teeth)) === tooth ||
      Math.max(...Array.from(teeth)) === tooth
    );
  }

  getToothColorForVisual(tooth: string): string {
    return this.toothSelectionService.getToothColorForVisual(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  getTextColorForVisual(tooth: string): string {
    return this.toothSelectionService.getTextColorForVisual(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  numbersAsString(numbers: number[]): string {
    return numbers.join(", ");
  }

  showMenu: boolean = false;
  menuPosition = { x: 0, y: 0 };
  rightClickedTooth: number = 0;

  refreshBridges() {
    var selectedTeeth = this.orderDetailsNew.toothData
      .filter((data) => data.bridgeConnectionType != "" && data.selected)
      .map((data) => data.teeth)
      .flat();
    var selectedTeethUpper = this.teethList.filter((teeth) =>
      selectedTeeth.includes(teeth),
    );
    // selectedTeethUpper.sort((a, b) => this.teethList.indexOf(a) - this.teethList.indexOf(b));
    if (selectedTeethUpper.length > 0) {
      var bridgesToRemove: any[] = [];
      this.orderDetailsNew.bridges.forEach((bridge) => {
        var isSame =
          bridge.bridgedTeeth.every((teeth) =>
            selectedTeethUpper.includes(teeth),
          ) &&
          selectedTeethUpper.every((teeth) =>
            bridge.bridgedTeeth.includes(teeth),
          );
        if (
          !isSame &&
          bridge.bridgedTeeth.some((teeth) =>
            selectedTeethUpper.includes(teeth),
          )
        ) {
          selectedTeethUpper = Array.from(
            new Set([...bridge.bridgedTeeth, ...selectedTeethUpper]),
          );
          bridgesToRemove.push(bridge);
        }
      });

      bridgesToRemove.forEach((bridge) => {
        this.orderDetailsNew.bridges.splice(
          this.orderDetailsNew.bridges.indexOf(bridge),
          1,
        );
      });

      selectedTeethUpper.sort(
        (a, b) => this.teethList.indexOf(a) - this.teethList.indexOf(b),
      );
      this.orderDetailsNew.bridges.push({
        bridgedTeeth: selectedTeethUpper,
        start: selectedTeethUpper[0],
        end: selectedTeethUpper[selectedTeethUpper.length - 1],
        bridgeConnectionType: "Strong connection",
      });
    }
  }

  removeToothFromBridge(toothId: number) {
    this.orderDetailsNew.bridges.forEach((bridge) => {
      if (bridge.bridgedTeeth.includes(toothId)) {
        var index = bridge.bridgedTeeth.indexOf(toothId);
        if (index == 0) {
          bridge.start = bridge.bridgedTeeth[1];
        } else if (index == bridge.bridgedTeeth.length - 1) {
          bridge.end = bridge.bridgedTeeth[bridge.bridgedTeeth.length - 2];
        }
        bridge.bridgedTeeth.splice(index, 1);
        if (bridge.bridgedTeeth.length == 1) {
          this.orderDetailsNew.toothData
            .filter((data) => data.teeth == bridge.bridgedTeeth[0])
            .forEach((data) => {
              data.bridgeConnectionType = "";
            });
          this.orderDetailsNew.bridges.splice(
            this.orderDetailsNew.bridges.indexOf(bridge),
            1,
          );
        }
      }
    });

    var ponticTeeths = this.orderDetailsNew.toothData
      .filter((data) => data.subType == "Pontic")
      .map((data) => data.teeth)
      .flat();

    this.orderDetailsNew.bridges.forEach((bridge) => {
      if (bridge.bridgedTeeth.every((teeth) => ponticTeeths.includes(teeth))) {
        this.orderDetailsNew.bridges.splice(
          this.orderDetailsNew.bridges.indexOf(bridge),
          1,
        );
        bridge.bridgedTeeth.forEach((teeth) => {
          this.orderDetailsNew.toothData
            .filter((data) => data.teeth == teeth)
            .forEach((data) => {
              data.bridgeConnectionType = "";
            });
        });
      }
    });
  }

  onRightClick(event: MouseEvent, tooth: number): void {
    event.preventDefault();
    const targetElement =
      event.target instanceof HTMLElement
        ? event.target
        : (event.currentTarget as HTMLElement);
    const rect = targetElement.getBoundingClientRect();

    this.menuPosition = {
      x: event.clientX + 2,
      y: event.clientY + 2,
    };

    this.rightClickedTooth = tooth;
    this.showMenu = true;
  }

  id: number = Date.now();

  teethList = [
    18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28, 48, 47, 46,
    45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
  ];
  teethListUpper: number[] = [
    18, 17, 16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26, 27, 28,
  ];
  teethListLower: number[] = [
    48, 47, 46, 45, 44, 43, 42, 41, 31, 32, 33, 34, 35, 36, 37, 38,
  ];

  currentViewPage: String = "first";

  selectedEventNext: Boolean = false;

  async onToothClick(
    toothIdStr: string,
    recursiveCall: boolean = false,
  ): Promise<void> {
    var toothId = Number(toothIdStr);

    if (this.orderDetailsNew.showAi) {
      var invalidAiToothSelection = false;

      var leftToothUpper =
        this.teethListUpper[this.teethListUpper.indexOf(toothId) - 1];
      var rightToothUpper =
        this.teethListUpper[this.teethListUpper.indexOf(toothId) + 1];

      var leftToothLower =
        this.teethListLower[this.teethListLower.indexOf(toothId) - 1];
      var rightToothLower =
        this.teethListLower[this.teethListLower.indexOf(toothId) + 1];

      this.orderDetailsNew.toothData
        .filter((data) => data.selected || data.type != "")
        .some((data) => {
          if (data.teeth == toothId) {
            return false;
          } else if (
            data.teeth == leftToothUpper ||
            data.teeth == rightToothUpper ||
            data.teeth == leftToothLower ||
            data.teeth == rightToothLower
          ) {
            invalidAiToothSelection = true;
            return true;
          } else {
            return false;
          }
        });

      if (invalidAiToothSelection) {
        this.dialogService
          .openMessageDialog(
            "Warning",
            "A tooth can only be selected if it has neighboring teeth mesially and distally.",
          )
          .subscribe();
        return;
      }
    }

    var selectedTeeth = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .map((data) => data.teeth)
      .flat();

    if (this.shiftKeyPressed && !recursiveCall && selectedTeeth.length > 0) {
      //upper start
      var selectedTeethUpper = this.teethListUpper.filter((teeth) =>
        selectedTeeth.includes(teeth),
      );

      selectedTeethUpper.sort(
        (a, b) =>
          this.teethListUpper.indexOf(a) - this.teethListUpper.indexOf(b),
      );

      var start = false;
      var toothAdded = false;

      this.teethListUpper.forEach((teeth) => {
        if (selectedTeethUpper.includes(teeth) && !start) {
          if (!toothAdded) {
            start = true;
          }
        } else if (teeth == toothId && !start) {
          this.onToothClick(teeth.toString(), true);
          start = true;
        } else if (start && selectedTeethUpper.includes(teeth)) {
          if (toothAdded) {
            start = false;
          }
        } else if (teeth == toothId && start) {
          this.onToothClick(teeth.toString(), true);
          start = false;
        } else if (start && !selectedTeethUpper.includes(teeth)) {
          this.onToothClick(teeth.toString(), true);
        }

        if (teeth == toothId) {
          toothAdded = true;
        }
      });
      //upper end

      //lower start
      var selectedTeethLower = this.teethListLower.filter((teeth) =>
        selectedTeeth.includes(teeth),
      );

      selectedTeethLower.sort(
        (a, b) =>
          this.teethListLower.indexOf(a) - this.teethListLower.indexOf(b),
      );

      var start = false;
      var toothAdded = false;

      this.teethListLower.forEach((teeth) => {
        if (selectedTeethLower.includes(teeth) && !start) {
          if (!toothAdded) {
            start = true;
          }
        } else if (teeth == toothId && !start) {
          this.onToothClick(teeth.toString(), true);
          start = true;
        } else if (start && selectedTeethLower.includes(teeth)) {
          if (toothAdded) {
            start = false;
          }
        } else if (teeth == toothId && start) {
          this.onToothClick(teeth.toString(), true);
          start = false;
        } else if (start && !selectedTeethLower.includes(teeth)) {
          this.onToothClick(teeth.toString(), true);
        }

        if (teeth == toothId) {
          toothAdded = true;
        }
      });
      //lower end
      return;
    }

    const index = this.orderDetailsNew.toothData.findIndex(
      (data) => data.teeth == Number(toothIdStr),
    );

    // select original value of the selected
    const wasSelected =
      index !== -1 ? this.orderDetailsNew.toothData[index].selected : false;

    if (index === -1) {
      this.orderDetailsNew.toothData.push({
        teeth: Number(toothIdStr),
        selected: true,
        id: this.id,
        type: "",
        subType: "",
        minimalThickness: 0.5,
        cementGap: 0.015,
        marginGap: 0.5,
        horizontalBorder: 0.015,
        radiusCompensation: 0.5,
        bridgeConnectionType: "",
        props: this.props.reduce((map, prop) => {
          map[prop.name] = prop.value;
          return map;
        }, {}),
      });
    } else if (this.orderDetailsNew.toothData[index].subType == "") {
      this.orderDetailsNew.toothData.splice(index, 1);
      this.removeToothFromBridge(toothId);
    } else if (
      index !== -1 &&
      this.orderDetailsNew.toothData[index].subType !== "" &&
      !wasSelected
    ) {
      this.availableSubTypes = this.subTypes.filter(
        (subType: any) => subType.parent == selectedTeethType,
      );
      this.orderDetailsNew.toothData[index].selected = true;
    } else {
      this.orderDetailsNew.toothData[index].selected = !wasSelected;
    }

    this.refreshAvailableTypes();
    var selectedTeethType = this.orderDetailsNew.toothData.find(
      (data) => data.selected,
    )?.type;
    if (selectedTeethType != "Bridge") {
      this.availableSubTypes = this.subTypes.filter(
        (subType: any) => subType.parent == selectedTeethType,
      );
    }
  }

  redCircle(toothId: number): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.teeth == toothId && data.selected,
    );
  }

  changeVIewType(lable: String) {
    this.currentViewPage = lable;
  }

  get checkSelectedToothSubTypeNotEmpty(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.selected && data.subType != "",
    );
  }

  // onSubTypeNextButton(){

  //   this.orderDetailsNew.toothData.filter(data => data.selected).forEach(data => {
  //     if(data.subType != ''){
  //       this.onSubTypeChange(data.subType, true)
  //     }
  //   });

  // }

  teethType: string = "";

  onTypeChange(typeName: string) {
    setTimeout(() => {
      this.setDefaultMaterial();
    }, 0);
    // this.currentToothData.type = typeName;
    // if (typeName != 'Bridge') {
    //   this.availableSubTypes = this.subTypes.filter((subType: any) => subType.parent == typeName);
    // }

    if (this.orderDetailsNew.showAi) {
      this.availableSubTypes = this.availableSubTypes.filter(
        (subType: any) => subType.name == "Crown",
      );
    }

    if (typeName == "Anatomy") {
      this.teethType = typeName;
      this.isAbustmentSelect = false;
      var selectedSubType = this.orderDetailsNew.toothData.filter(
        (data) => data.selected,
      )[0].subType;
      var selectedType = this.orderDetailsNew.toothData.filter(
        (data) => data.selected,
      )[0].type;
      var allSelectedSameSubType = this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .every((data) => data.subType == selectedSubType);

      this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .forEach((data) => {
          if (data.subType == "") {
            data.subType = selectedSubType ? selectedSubType : "Crown";
            data.type = selectedType ? selectedType : "Anatomy";
          } else if (selectedSubType != "" && !allSelectedSameSubType) {
            data.subType = selectedSubType;
            data.type = selectedType;
          } else {
            data.subType = "";
            data.type = "";
            data.bridgeConnectionType = "";
            this.removeToothFromBridge(data.teeth);
          }
        });
    }

    if (typeName == "Frame") {
      this.teethType = typeName;
      this.isAbustmentSelect = false;

      var selectedSubType = this.orderDetailsNew.toothData.filter(
        (data) => data.selected,
      )[0].subType;
      var selectedType = this.orderDetailsNew.toothData.filter(
        (data) => data.selected,
      )[0].type;
      var allSelectedSameSubType = this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .every((data) => data.subType == selectedSubType);

      this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .forEach((data) => {
          if (data.subType == "") {
            data.subType = selectedSubType ? selectedSubType : "Crown";
            data.type = selectedType ? selectedType : "Frame";
          } else if (selectedSubType != "" && !allSelectedSameSubType) {
            data.subType = selectedSubType;
            data.type = selectedType;
          } else {
            data.subType = "";
            data.type = "";
            data.bridgeConnectionType = "";
            this.removeToothFromBridge(data.teeth);
          }
        });
    }

    // if(typeName == 'Frame'){
    //   var selectedSubType = this.orderDetailsNew.toothData.filter(data => data.selected)[0].subType;
    //   var selectedType = this.orderDetailsNew.toothData.filter(data => data.selected)[0].type;
    //   var allSelectedSameSubType = this.orderDetailsNew.toothData.filter(data => data.selected).every(data => data.subType == selectedSubType);

    //   this.orderDetailsNew.toothData.filter(data => data.selected).forEach(data => {
    //     if(data.subType == ''){
    //       data.subType = selectedSubType ? selectedSubType : 'Zirkon coping';
    //       data.type = selectedType ? selectedType : 'Frame';
    //     }else if (selectedSubType != '' && !allSelectedSameSubType){
    //       data.subType = selectedSubType;
    //       data.type = selectedType;
    //     }else{
    //       data.subType = '';
    //       data.type = '';
    //       // data.bridgeConnectionType = '';
    //       // this.removeToothFromBridge(data.teeth);
    //     }
    //   });
    // }

    //alert if teeth between selected teeth as per the teeth list are already having type
    var selectedTeeth = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .map((data) => data.teeth)
      .flat();
    var selectedTeethUpper = this.teethListUpper.filter((teeth) =>
      selectedTeeth.includes(teeth),
    );
    selectedTeethUpper.sort(
      (a, b) => this.teethListUpper.indexOf(a) - this.teethListUpper.indexOf(b),
    );
    var selectedTeethLower = this.teethListLower.filter((teeth) =>
      selectedTeeth.includes(teeth),
    );
    selectedTeethLower.sort(
      (a, b) => this.teethListLower.indexOf(a) - this.teethListLower.indexOf(b),
    );
    var selectedTeethUpperStart = selectedTeethUpper[0];
    var selectedTeethUpperEnd =
      selectedTeethUpper[selectedTeethUpper.length - 1];
    var selectedTeethLowerStart = selectedTeethLower[0];
    var selectedTeethLowerEnd =
      selectedTeethLower[selectedTeethLower.length - 1];

    // var selectedTeethUpperBetween = this.teethListUpper.filter(teeth => teeth > selectedTeethUpperStart && teeth < selectedTeethUpperEnd);
    // var selectedTeethLowerBetween = this.teethListLower.filter(teeth => teeth > selectedTeethLowerStart && teeth < selectedTeethLowerEnd);
    const startIdxUpper = this.teethListUpper.indexOf(selectedTeethUpperStart);
    const endIdxUpper = this.teethListUpper.indexOf(selectedTeethUpperEnd);
    const selectedTeethUpperBetween = this.teethListUpper.filter(
      (_, idx) => idx > startIdxUpper && idx < endIdxUpper,
    );

    const startIdxLower = this.teethListLower.indexOf(selectedTeethLowerStart);
    const endIdxLower = this.teethListLower.indexOf(selectedTeethLowerEnd);
    const selectedTeethLowerBetween = this.teethListLower.filter(
      (_, idx) => idx > startIdxLower && idx < endIdxLower,
    );

    var selectedTeethUpperBetweenData = this.orderDetailsNew.toothData.filter(
      (data) =>
        selectedTeethUpperBetween.includes(data.teeth) &&
        data.type != "" &&
        typeName == "Bridge" &&
        !data.selected,
    );
    var selectedTeethLowerBetweenData = this.orderDetailsNew.toothData.filter(
      (data) =>
        selectedTeethLowerBetween.includes(data.teeth) &&
        data.type != "" &&
        typeName == "Bridge" &&
        !data.selected,
    );
    if (
      selectedTeethUpperBetweenData.length > 0 ||
      selectedTeethLowerBetweenData.length > 0
    ) {
      var selectedTeethUpperBetweenDataStr = selectedTeethUpperBetweenData
        .map((data) => data.teeth)
        .join(", ");
      var selectedTeethLowerBetweenDataStr = selectedTeethLowerBetweenData
        .map((data) => data.teeth)
        .join(", ");
      // var selectedTeethUpperBetweenDataStr = selectedTeethUpperBetweenDataStr == '' ? '' : 'Upper: ' + selectedTeethUpperBetweenDataStr;
      // var selectedTeethLowerBetweenDataStr = selectedTeethLowerBetweenDataStr == '' ? '' : 'Lower: ' + selectedTeethLowerBetweenDataStr;
      this.dialogService
        .openMessageDialog(
          "Warning",
          "The following teeth should be selected for bridge: " +
            selectedTeethUpperBetweenDataStr +
            selectedTeethLowerBetweenDataStr,
        )
        .subscribe();
      return;
    }
     var toothToRemoveFromBridge: number[] = [];

    var allSelectedBridge = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .every((data) => data.bridgeConnectionType != "");

    this.orderDetailsNew.toothData.filter(data => data.selected).forEach(data => {

      var bridgeIndex = this.orderDetailsNew.bridges.length;

      if (typeName == 'Bridge') {

        if (data.bridgeConnectionType == '') {
          data.bridgeConnectionType = 'Strong connection';
          if (this.dataService.anteriorTeeth.includes(data.teeth)) {
            this.orderDetailsNew.props['bridgeConnectionType-anterior-' + bridgeIndex] = 'Strong connection';
            this.orderDetailsNew.props['bridgeConnectionType-anterior-frame-' + bridgeIndex] = 'Strong connection';
          } else {
            this.orderDetailsNew.props['bridgeConnectionType-posterior-' + bridgeIndex] = 'Strong connection';
            this.orderDetailsNew.props['bridgeConnectionType-posterior-frame-' + bridgeIndex] = 'Strong connection';
          }
        } else if (allSelectedBridge && data.bridgeConnectionType != '') {
          data.bridgeConnectionType = '';
          // data.type = '';
          toothToRemoveFromBridge.push(data.teeth);
        }
        // else{
        //   data.bridgeConnectionType = '';
        //   // data.type = '';
        //   toothToRemoveFromBridge.push(data.teeth);
        // }
      }
      // else{
      //   data.bridgeConnectionType = '';

          //   if(data.type == ''){
          //     data.type = typeName;
          //   }else{
          //     data.type = '';
          //     data.subType = '';
          //   }
          // }

          if (typeName == "Abutment") {
            this.teethType = typeName;
            this.isAbustmentSelect = true;
            this.abutmentTeeth = [];

            const selectedTooth = this.orderDetailsNew.toothData.find(
              (data) => data.selected,
            );
            if (!selectedTooth) return; // no teeth selected

            const selectedSubType = selectedTooth.subType || "Abutment";
            const selectedType = selectedTooth.type || "Abutment";

            // Assign same type/subType to all selected teeth
            this.orderDetailsNew.toothData
              .filter((data) => data.selected)
              .forEach((data) => {
                data.subType = selectedSubType;
                data.type = selectedType;
              });

            this.setAbutmentTeeth();

            setTimeout(() => {
              const abutmentStep1 = this.abutmentStep1?.nativeElement;
              const abutmentStep2 = this.abutmentStep2?.nativeElement;

              this.abutmentStep1Instance = abutmentStep1
                ? bootstrap?.Collapse?.getOrCreateInstance
                  ? bootstrap.Collapse.getOrCreateInstance(abutmentStep1, {
                      toggle: false,
                    })
                  : undefined
                : undefined;
              this.abutmentStep1Instance?.show();

              this.abutmentStep2Instance = abutmentStep2
                ? bootstrap?.Collapse?.getOrCreateInstance
                  ? bootstrap.Collapse.getOrCreateInstance(abutmentStep2, {
                      toggle: false,
                    })
                  : undefined
                : undefined;
              this.abutmentStep2Instance?.hide();
            });
          }
        },

        toothToRemoveFromBridge.forEach((toothId) =>
          this.removeToothFromBridge(toothId),
        ),
      );

    this.refreshBridges();
    console.log("Before refreshProps", this.orderDetailsNew.props);
    this.refreshProps();
    console.log("After refreshProps", this.orderDetailsNew.props);
    this.refreshAvailableTypes();
  }

  get bridgeConnectionTypeBySelectedTeeth(): string {
    return (
      this.orderDetailsNew.toothData
        .filter((data) => data.selected && data.bridgeConnectionType)
        .map((data) => data.bridgeConnectionType)[0] || ""
    );
  }
  get abutmentSelectedTeeth(): number[] {
    return this.abutmentService.abutmentSelectedTeeth;
  }
  set abutmentSelectedTeeth(v: number[]) {
    this.abutmentService.abutmentSelectedTeeth = v;
  }
  get teethWithCompleteData(): number[] {
    return this.abutmentService.teethWithCompleteData;
  }
  set teethWithCompleteData(v: number[]) {
    this.abutmentService.teethWithCompleteData = v;
  }

  setAbutmentTeeth() {
    this.abutmentService.setAbutmentTeeth(this.orderDetailsNew.toothData);
  }

  setAbutmentSelectedTooth(tooth: number) {
    this.abutmentService.setAbutmentSelectedTooth(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  updateFilledTeethCount() {
    this.abutmentService.updateFilledTeethCount(this.orderDetailsNew.toothData);
  }

  areAllTeethSelected(): boolean {
    return this.abutmentService.areAllTeethSelected();
  }

  toggleSelectAll(checked: boolean) {
    this.abutmentService.toggleSelectAll(checked);
  }

  showAnatomyCircle(tooth: number): boolean {
    // return this.orderDetailsNew.toothData.some(data => data.teeth == tooth && data.type == 'Anatomy');
    return false;
  }

  onSubTypeChange(subTypeName: string) {
    // if(subTypeName == 'Bridge'){
    //   return;
    // }

    var selectedSubType = this.orderDetailsNew.toothData.filter(
      (data) => data.selected,
    )[0].subType;
    var allSelectedSameSubType = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .every((data) => data.subType == selectedSubType);

    this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .forEach((data) => {
        // if(data.subType != subTypeName){
        //   data.subType = subTypeName;
        //   this.subTypes.filter((subType: any) => subType.name == subTypeName).forEach((subType: any) => {
        //     data.type = subType.parent;
        //   });
        // }else{
        //   data.subType = '';
        // }

        // if(data.subType != subTypeName){
        //   data.subType = subTypeName;
        // }else
        if (data.subType == "") {
          data.subType = subTypeName;
        } else if (selectedSubType != "" && !allSelectedSameSubType) {
          data.subType = subTypeName;
        } else if (data.subType != subTypeName) {
          data.subType = subTypeName;
        } else {
          data.subType = "";
        }
      });
    this.refreshProps();
    this.id = Date.now();
    this.refreshAvailableTypes();
  }

  isTypeSelected(typeName: string): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.selected && data.type == typeName,
    );
  }

  isSubTypeSelected(subTypeName: string): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.selected && data.subType == subTypeName,
    );
  }

  get checkToothSelectedIsBridge(): boolean {
    const selectedToothData = this.orderDetailsNew.toothData.filter(
      (data) => data.selected,
    );
    return (
      selectedToothData.length > 0 &&
      selectedToothData.some((data) => data.bridgeConnectionType != "")
    );
  }

  get checkToothAndTypeSelected(): boolean {
    return (
      this.orderDetailsNew.toothData.filter(
        (data) => data.selected && data.type != "",
      ).length > 0
    );
  }

  getToothColor(tooth: string): string {
    return this.toothSelectionService.getToothColor(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  isToothSelected(tooth: string): boolean {
    return this.toothSelectionService.isToothSelected(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  getSubTypeByTooth(tooth: string): string {
    return this.toothSelectionService.getSubTypeByTooth(
      tooth,
      this.orderDetailsNew.toothData,
    );
  }

  refreshAvailableTypes() {
    const selectedTeethCount = this.orderDetailsNew.toothData.filter(
      (data) => data.selected,
    ).length;
    this.availableTypes =
      selectedTeethCount == 0
        ? []
        : this.types
            .map((type: any) => type.name)
            .filter(
              (typeName: string) =>
                typeName == "Anatomy" ||
                typeName == "Bridge" ||
                typeName == "Frame" ||
                typeName == "Abutment",
            )
            .filter((typeName: string) =>
              this.checkBridgeCondition() ? true : typeName != "Bridge",
            );

    var selectedType = this.orderDetailsNew.toothData.find(
      (data) => data.selected,
    )?.type;
    if (selectedType == "Anatomy") {
      this.availableTypes = this.availableTypes.filter(
        (type: any) => type != "Frame",
      );
      this.availableTypes = this.availableTypes.filter(
        (type: any) => type != "Abutment",
      );
    } else if (selectedType == "Frame") {
      this.availableTypes = this.availableTypes.filter(
        (type: any) => type != "Anatomy",
      );
      this.availableTypes = this.availableTypes.filter(
        (type: any) => type != "Abutment",
      );
    }

    if (this.orderDetailsNew.showAi) {
      this.availableTypes = this.availableTypes.filter(
        (type: any) => type == "Anatomy",
      );
    }

    // this.showSliderForToothType.value = !this.showSliderForToothType.value;
  }

  checkAnyBridgeSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.bridgeConnectionType != "",
    );
  }

  checkBridgeCondition(): boolean {
    const selectedToothData = this.orderDetailsNew.toothData.filter(
      (data) => data.selected,
    );
    const hasCrown = selectedToothData.some((data) => data.subType === "Crown");
    const hasCrownOrPontic = selectedToothData.every(
      (data) => data.subType === "Pontic" || data.subType === "Crown",
    );
    return (
      (selectedToothData.length >= 2 && hasCrown && hasCrownOrPontic) ||
      (hasCrownOrPontic &&
        this.orderDetailsNew.bridges.some((bridge) =>
          bridge.bridgedTeeth.some((teeth) =>
            selectedToothData.some((data) => data.teeth == teeth),
          ),
        ))
    );
  }

  checkTwoArrayMatch(array1: number[], array2: number[]): boolean {
    return (
      array1.length == array2.length &&
      array1.every((value, index) => value === array2[index])
    );
  }

  // editDetail(detail: ToothData): void {
  //   this.currentToothData = detail;
  //   this.refreshAvailableTypes();
  //   this.showSliderForToothType.value = !this.showSliderForToothType.value
  // }

  dialogRef!: MatDialogRef<any>;

  @ViewChild("dialogTemplate") dialogTemplate!: TemplateRef<any>;
  openDialog(): void {
    this.dialogRef = this.dialog.open(this.dialogTemplate, { width: "558px" });
  }

  editTaskFlag: boolean = false;

  ngOnInit() {
    // this.previousMaterialValue = this.getPropValue('Material') || '';
    this.clearAll();
    this.getLastTaskData();

    this.route.queryParamMap.subscribe((params) => {
      this.taskId = Number(params.get("taskId"));
    });

    if (this.taskId > 0) {
      this.editTaskFlag = true;
      this.dataService.updateTitle("Edit Task");
      this.dataService.updateProgressBarSubject(true);
      this.dataService.get("/tasks/" + this.taskId).subscribe({
        next: (response) => {
          this.orderDetailsNew = JSON.parse(response.jsonData);
          this.getTypesFromBackend();
          this.getSubTypesFromBackend();
          this.getPropsFromBackend();
          // Placeholder entry keeps the scan file array non-empty so downstream "at least one file" validation passes before real files load
          this.fileDetailsScan.push({
            fileId: 0,
            fileType: "",
            fileName: "",
            fileSize: 0,
          });
        },
        error: (err) => {
          this.dialogService.handleError(
            err,
            "Failed to get Task Details, Please try again.",
          );
        },
      });

      this.dataService.get("/tasks/" + this.taskId + "/files").subscribe({
        next: (files: any[]) => {
          // Only scan files are re-attached on edit; design/visual files are read-only and don't need re-upload
          files
            .filter((file) => file.fileType === "scan")
            .forEach((file) => {
              this.fileDetailsScan.push({
                fileId: file.fileId,
                fileType: file.fileType,
                fileName: file.fileName,
                fileSize: file.fileSize,
              });

              this.fileUploadService.initProgressForExistingFile(
                file.fileName,
                file.fileSize,
              );
            });
        },
        error: (err) => {},
      });
    } else {
      this.dataService.updateTitle("Create New Task");
      this.initCurrentToothData();
      this.createNewTaskId();
      this.getTypesFromBackend();
      this.getSubTypesFromBackend();
      this.getPropsFromBackend();

      const navigation = this.router.getCurrentNavigation();
      // Designer pre-selection is passed via query params from the designer search/profile pages
      this.route.queryParams.subscribe((params) => {
        if (params["designer"]) {
          this.orderDetailsNew.designer = params["designer"];
          this.orderDetailsNew.isFav = params["isFav"] === "true";
          this.orderDetailsNew.rating = params["rating"]
            ? Number(params["rating"])
            : 0;
          this.orderDetailsNew.experience = params["experience"]
            ? params["experience"]
            : "";
          this.orderDetailsNew.skill = params["skill"] ? params["skill"] : "";
          this.orderDetailsNew.software = params["software"]
            ? params["software"]
            : "";
        }
      });
      this.orderDetailsNew.showHuman = true;
    }
    // Pushes a dummy history entry so the browser back button navigates away rather than re-triggering this form with stale query params
    history.pushState({ dummy: true }, "", location.href);
  }

  ngOnDestroy(): void {
    this.uploadPolling?.unsubscribe();
  }

  createNewTaskId() {
    console.log("Creating new task ID");
    this.dataService.updateProgressBarSubject(true);
    this.dataService.post("/tasks", {}).subscribe({
      next: (response) => {
        this.taskId = response.taskId;
        localStorage.setItem("newCreatedTaskId", this.taskId.toString());
        this.orderDetailsNew.taskId = response.taskId;
        this.dataService.updateProgressBarSubject(false);

        this.generateQRCode();
      },
      error: (err) => {
        this.dialogService
          .handleError(err, "Failed to Create a New Task, Please try again.")
          .subscribe((result) => this.location.back());
      },
    });
  }

  hasAtLeastOneFile(): boolean {
    return Object.keys(this.fileUploadService.progress).length > 0;
  }

  getTypesFromBackend() {
    this.taskCrudService.getTypesFromBackend((types) => {
      this.types = types;
    });
  }

  getSubTypesFromBackend() {
    this.taskCrudService.getSubTypesFromBackend((subTypes) => {
      this.subTypes = subTypes;
    });
  }

  getPropsFromBackend() {
    this.taskCrudService.getPropsFromBackend((props) => {
      this.props = props;
    });
  }

  onClose(event?: Event): void {
    if (event) event.stopPropagation();
    this.materialService.resetMaterialState();
    this.dialogRef.close();
  }

  addNewMaterial() {
    this.materialService.addNewMaterial(
      this.currentProps,
      this.teethType,
      this.currentToothData,
      (props) => {
        this.props = props;
      },
      () => this.refreshProps(),
    );
  }

  toothDetailsArray: { tooth: string; indication: string; material: string }[] =
    [];

  propComponentsDefaultValues: any = {
    F: { q1Value: "Deep (standard)", q2Value: "Slight wear" },
    H: {
      q1Value: "Normal",
      q2Value: "Slight wear",
      q3Value: "0.03 mm light occlusion (standard)",
    },
    P: { q1Value: "0.7 mm standard" },
    A: {
      q1Value: "1/3 of the surface",
      q2Value: "0.03 mm light occlusion (standard)",
      q3Value:
        "Buccal light equator, approx. 1.6 mm distance cervical (Standard)",
    },
    B: {
      q1Value:
        "Oral light equator, approx. 1.6 mm distance cervical (Standard)",
    },
    PONTIC: {
      q1Value: "0.01 mm: Lightly resting on the gingiva",
      q2Value: "Pontic extension 1",
      q3Value: "Tangential",
    },
    articulation: {
      articulator: "Artex von Amann Girrbach",
      protrusionAngle: 30,
      bennettAngle: 15,
      iss: 0.5,
      incisalGuidance: 10,
      q2Value: -0.2,
    },
    V: {
      medianValue: 129,
      mesialValue: 0,
      q1Value: "default buccal/labial convexity",
    },
  };

  refreshProps() {
    // this.currentProps = this.props.filter(prop => prop.parent == this.currentToothData.type);
    this.currentProps = this.props.filter((prop) =>
      this.orderDetailsNew.toothData.some(
        (data) => data.selected && data.type == prop.parent,
      ),
    );
  }
  refreshPropsForXmlUpload() {
    // this.currentProps = this.props.filter(prop => prop.parent == this.currentToothData.type);
    this.currentProps = this.props.filter((prop) =>
      this.orderDetailsNew.toothData.some(
        (data) => !data.selected && data.type == prop.parent,
      ),
    );
  }
  previousMaterialValue: string = "";
  onPropChange(name: string, parent: string, event: Event) {
    const selectEl = event.target as HTMLSelectElement | null;
    if (!selectEl) return; // <-- prevents the TS error

    const valuee = selectEl.value;
    var value = (event.target as HTMLSelectElement).value;
    if (name == "Material") {
      this.materialService.loadMaterialParams(value, this.teethType);
    }
    this.previousMaterialValue = value;
    this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .forEach((data) => {
        data.props[name] = value;
      });

    var selectedTeeth = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .map((data) => data.teeth)
      .flat();
    this.orderDetailsNew.bridges.forEach((bridge) => {
      if (bridge.bridgedTeeth.some((teeth) => selectedTeeth.includes(teeth))) {
        bridge.bridgedTeeth.forEach((teeth) => {
          this.orderDetailsNew.toothData
            .filter((data) => data.teeth == teeth)
            .forEach((data) => {
              data.props[name] = value;
            });
        });
      }
    });
  }
  onDynamicParamChangeonDynamicParamChange(param: any) {}

  loadMaterialParams(material: string) {
    this.materialService.loadMaterialParams(material, this.teethType);
  }

  loadMaterialParamsForXmlUpload(material: string) {
    this.materialService.loadMaterialParamsForXmlUpload(
      material,
      this.teethType,
    );
  }

  getPropValue(name: string): string {
    var retnValue = this.currentProps.filter((prop) => prop.name == name)[0]
      .value;

    if (name === "Material") {
      const materialProp = this.currentProps.find((p) => p.name === "Material");

      if (materialProp && materialProp.values) {
        this.materialService.materialList = materialProp.values
          .split(",")
          .map((item: string) => item.trim());
        if (!this.materialService.materialList.includes(retnValue)) {
          retnValue =
            this.materialService.materialList[
              this.materialService.materialList.length - 1
            ];
        }
      }
    }
    this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .forEach((data) => {
        if (data.props[name]) {
          retnValue = data.props[name];
        }
      });
    return retnValue;
  }

  onParamChange(name: string, event: Event) {
    var value = (event.target as HTMLSelectElement).value;

    this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .forEach((data) => {
        data[name] = value;
      });

    var selectedTeeth = this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .map((data) => data.teeth)
      .flat();
    this.orderDetailsNew.bridges.forEach((bridge) => {
      if (bridge.bridgedTeeth.some((teeth) => selectedTeeth.includes(teeth))) {
        bridge.bridgedTeeth.forEach((teeth) => {
          this.orderDetailsNew.toothData
            .filter((data) => data.teeth == teeth)
            .forEach((data) => {
              data[name] = value;
            });
        });
      }
    });
  }

  getParamValue(name: string): string {
    var retnValue = "";
    this.orderDetailsNew.toothData
      .filter((data) => data.selected)
      .forEach((data) => {
        if (data[name]) {
          retnValue = data[name];
        }
      });
    return retnValue;
  }

  containsSelectedTeeth(input: string): number[] {
    const teethNumbers = this.invertToothNumbers(input);
    if (
      teethNumbers.some((toothNumber) => this.selectedTeethSet.has(toothNumber))
    ) {
      return teethNumbers;
    } else {
      return [];
    }
  }

  combineToothNumbers(input: number[]): string {
    return this.dataService.combineToothNumbers(input);
  }

  invertToothNumbers(input: string): number[] {
    return this.dataService.invertToothNumbers(input);
  }

  getProcDesc(data: any) {
    var desc = this.combineToothNumbers(Array.from(data.teeth))
      .concat(", ")
      .concat(data.type)
      .concat(", ")
      .concat(data.subType);
    data.props.forEach(
      (prop: any) => (desc += ", <b>" + prop.name + "</b>: " + prop.value),
    );
    data.quesAns.forEach(
      (qa: any) => (desc += ", <b>" + qa.ques + "</b>: " + qa.ans),
    );
    return desc;
  }

  async saveTask() {
    const pdfBlob: Blob = await this.taskDetails.generatePDF(
      this.taskId.toString(),
    );
    this.taskCrudService.saveTask(
      this.taskId,
      this.orderDetailsNew,
      pdfBlob,
      () => {
        this.allowPageLeave = true;
      },
    );
  }

  async editTask() {
    const pdfBlob: Blob = await this.taskDetails.generatePDF(
      this.taskId.toString(),
    );
    this.taskCrudService.editTask(
      this.taskId,
      this.orderDetailsNew,
      pdfBlob,
      () => {
        this.clearAll();
        this.router.navigate(["/dashboard"]);
      },
    );
  }

  deleteTask() {
    this.taskCrudService.deleteTask(this.taskId, () => this.location.back());
  }

  openUsersModal() {
    const dialogRef = this.dialog.open(DesignerSearchComponent, {
      width: "95%",
      maxWidth: "1100px",
      height: "80%",
      maxHeight: "80vh",
      data: {
        designer: this.orderDetailsNew.designer,
        isFav: this.orderDetailsNew.isFav,
        rating: this.orderDetailsNew.rating,
        experience: this.orderDetailsNew.experience,
        skill: this.orderDetailsNew.skill,
        software: this.orderDetailsNew.software,
      },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.designer) {
        this.orderDetailsNew.designer = result.designer;
        this.orderDetailsNew.isFav = result.isFav;
        this.orderDetailsNew.rating = result.rating;
        this.orderDetailsNew.experience = result.experience;
        this.orderDetailsNew.skill = result.skill;
        this.orderDetailsNew.software = result.software;
      }
    });
  }
  @ViewChild(TaskDetailsComponent) taskDetails!: TaskDetailsComponent;

  deliveryTimeAsperDesignLevel = new Map<string, string[]>([
    ["silver", ["24"]],
    ["gold", ["24", "12"]],
    ["platinum", ["24", "12", "8"]],
  ]);

  timePriceMap = new Map<string, string>([
    ["silver-24", ""],
    ["gold-24", ""],
    ["gold-12", "(€ +2.99 / Unit)"],
    ["platinum-24", ""],
    ["platinum-12", "(€ +2.99 / Unit)"],
    ["platinum-8", "(€ +4.99 / Unit)"],
  ]);

  onTierChange(selectedTier: string) {
    this.orderDetailsNew.tier = selectedTier;
    this.orderDetailsNew.remainingCorrections =
      this.orderDetailsNew.tier == "silver"
        ? 1
        : this.orderDetailsNew.tier == "gold"
          ? 2
          : 4;
    this.orderDetailsNew.deliveryTime = "24";
  }

  get anteriorSelectedTeeth(): number[] {
    return this.dataService.groupByAnteriorAndPosterior(
      this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .map((data) => data.teeth),
    ).anterior;
  }
  get posteriorSelectedTeeth(): number[] {
    return this.dataService.groupByAnteriorAndPosterior(
      this.orderDetailsNew.toothData
        .filter((data) => data.selected)
        .map((data) => data.teeth),
    ).posterior;
  }

  get anteriorBridgedTeethFrame_1(): number[] {
    var bridgedTeeth = this.orderDetailsNew.bridges
      .map((b) => b.bridgedTeeth)
      .flat();
    if (
      bridgedTeeth.some((teeth) =>
        this.orderDetailsNew.toothData.some(
          (data) => data.teeth == teeth && data.type == "Frame",
        ),
      )
    ) {
      return this.dataService.groupByAnteriorAndPosterior_1(bridgedTeeth)
        .anterior;
    } else {
      return [];
    }

    // return this.dataService.groupByAnteriorAndPosterior(this.orderDetailsNew.bridges.map(b => b.bridgedTeeth).flat()).anterior;
  }

  get posteriorBridgedTeethFrame_1(): number[] {
    var bridgedTeeth = this.orderDetailsNew.bridges
      .map((b) => b.bridgedTeeth)
      .flat();
    if (
      bridgedTeeth.some((teeth) =>
        this.orderDetailsNew.toothData.some(
          (data) => data.teeth == teeth && data.type == "Frame",
        ),
      )
    ) {
      return this.dataService.groupByAnteriorAndPosterior_1(bridgedTeeth)
        .posterior;
    } else {
      return [];
    }

    // return this.dataService.groupByAnteriorAndPosterior(this.orderDetailsNew.bridges.map(b => b.bridgedTeeth).flat()).posterior;
  }

  anteriorBridgedTeethFrame(bridgedTeeth: number[]): number[] {
    return this.dataService.anteriorBridgedTeethFrame(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  posteriorBridgedTeethFrame(bridgedTeeth: number[]): number[] {
    return this.dataService.posteriorBridgedTeethFrame(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  get bridgedTeethFrame(): number[] {
    var bridgedTeeth = this.orderDetailsNew.bridges
      .map((b) => b.bridgedTeeth)
      .flat();
    if (
      bridgedTeeth.some((teeth) =>
        this.orderDetailsNew.toothData.some(
          (data) => data.teeth == teeth && data.type == "Frame",
        ),
      )
    ) {
      return bridgedTeeth;
    } else {
      return [];
    }
  }

  anteriorBridgedTeeth(bridgedTeeth: number[]): number[] {
    return this.dataService.anteriorBridgedTeeth(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  posteriorBridgedTeeth(bridgedTeeth: number[]): number[] {
    return this.dataService.posteriorBridgedTeeth(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  get anteriorPonticTeeth(): number[] {
    return this.dataService.anteriorPonticTeeth(this.orderDetailsNew);
  }

  get posteriorPonticTeeth(): number[] {
    return this.dataService.posteriorPonticTeeth(this.orderDetailsNew);
  }

  get anteriorTeethForAnatomy(): number[] {
    return this.dataService.anteriorTeethForAnatomy(this.orderDetailsNew);
  }

  get posteriorTeethForAnatomy(): number[] {
    return this.dataService.posteriorTeethForAnatomy(this.orderDetailsNew);
  }

  get anteriorTeeth(): number[] {
    return this.dataService.groupByAnteriorAndPosterior(
      this.orderDetailsNew.toothData.map((data) => data.teeth),
    ).anterior;
  }

  get posteriorTeeth(): number[] {
    return this.dataService.groupByAnteriorAndPosterior(
      this.orderDetailsNew.toothData.map((data) => data.teeth),
    ).posterior;
  }

  anteriorTeethForCrownOrPonticFrame(bridgedTeeth: number[]): number[] {
    return this.dataService.anteriorTeethForCrownOrPonticFrame(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  posteriorTeethForCrownOrPonticFrame(bridgedTeeth: number[]): number[] {
    return this.dataService.posteriorTeethForCrownOrPonticFrame(
      this.orderDetailsNew,
      bridgedTeeth,
    );
  }

  get anteriorTeethForFrame_1(): number[] {
    return this.dataService.anteriorTeethForFrame_1(this.orderDetailsNew);
  }

  get posteriorTeethForFrame_1(): number[] {
    return this.dataService.posteriorTeethForFrame_1(this.orderDetailsNew);
  }

  get anteriorTeethForCrownOrPontic(): number[] {
    return this.dataService.anteriorTeethForCrownOrPontic(this.orderDetailsNew);
  }

  get posteriorTeethForCrownOrPontic(): number[] {
    return this.dataService.posteriorTeethForCrownOrPontic(
      this.orderDetailsNew,
    );
  }

  get isAnatomyCrownSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Crown" && data.type == "Anatomy",
    );
  }
  get isAnatomyPonticSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Pontic" && data.type == "Anatomy",
    );
  }
  get isAnatomyInlayOnlaySelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Inlay/Onlay" && data.type == "Anatomy",
    );
  }
  get isAnatomyVeneerSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Veneer" && data.type == "Anatomy",
    );
  }

  get isFrameCrownSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Crown" && data.type == "Frame",
    );
  }
  get isFramePonticSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Pontic" && data.type == "Frame",
    );
  }
  get isFrameInlayOnlaySelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Inlay/Onlay" && data.type == "Frame",
    );
  }
  get isFrameVeneerSelected(): boolean {
    return this.orderDetailsNew.toothData.some(
      (data) => data.subType == "Veneer" && data.type == "Frame",
    );
  }

  get isBridgeSelected(): boolean {
    return this.orderDetailsNew.bridges.length > 0;
  }

  validateToothSelection() {
    var noPonticWithoutBridge: boolean =
      this.orderDetailsNew.toothData.filter(
        (data) => data.subType == "Pontic" && data.bridgeConnectionType == "",
      ).length == 0;
    if (!noPonticWithoutBridge) {
      this.dialogService
        .openMessageDialog("Warning!", "Only Pontic is not allowed.")
        .subscribe();
      return false;
    }

    if (
      this.orderDetailsNew.toothData.filter(
        (data) => data.type != "" && data.subType != "",
      ).length == 0
    ) {
      this.dialogService
        .openMessageDialog(
          "Warning!",
          "Please select at least one tooth and type to proceed.",
        )
        .subscribe();
      return false;
    }
    // Abutment validation
    if (this.isAbustmentSelect) {
      if (!this.validateAbutmentSteps()) {
        return false;
      }
    }

    if (noPonticWithoutBridge) {
      this.stepper.next();
      return true;
    }

    return false;
  }

  abutmentSelectedTeethAllData: number[] = [];

  validateToothSelectionForSpecificTooth(): void {
    this.abutmentService.validateToothSelectionForSpecificTooth(
      this.orderDetailsNew.toothData,
      () => this.goToNextStep(),
    );
  }

  validateAbutmentSteps(): boolean {
    return this.abutmentService.validateAbutmentSteps(
      this.orderDetailsNew.toothData,
      this.isAbustmentSelect,
    );
  }

  openFilesModalForDownload() {
    this.dialog
      .open(FilesComponent, {
        disableClose: true,
        width: "60%",
        height: "80%",
        data: { taskId: this.taskId, refNum: this.orderDetailsNew.refNum },
      })
      .afterClosed()
      .subscribe((result) => {
        this.fileDetailsScan = result.fileDetailsScan;
        this.fileDetailsImages = result.fileDetailsImages;
        this.fileDetailsImagesContent = result.fileDetailsImagesContent;
      });
  }

  openVideoDialog(): void {
    this.dialog.open(VideoDialogComponent, {
      minWidth: "60vw",
      minHeight: "60vh",
    });
  }

  move(index: number) {
    this.stepper.selectedIndex = index;
  }

  @ViewChild("scanFile") fileInput!: ElementRef<HTMLInputElement>;

  // --- Drag and Drop Handlers ---
  @HostListener("dragover", ["$event"]) onDragOver(event: DragEvent) {
    event.preventDefault(); // Prevent default browser behavior
    event.stopPropagation();
    // Add a class for visual feedback (e.g., this.isDragging = true;)
  }

  @HostListener("dragleave", ["$event"]) onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    // Remove visual feedback class (e.g., this.isDragging = false;)
  }

  @ViewChild("scanFile") scanFile!: ElementRef<HTMLInputElement>;
  openScanPicker() {
    this.scanFile.nativeElement.click();
  }
  uploadSingleFile(file: File, fileType: string) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService
      .postFile("/tasks/" + this.taskId + "/files", file)
      .subscribe({
        next: (response) => {
          this.fileDetailsScan.push({
            fileId: 0,
            fileType: fileType,
            fileName: file.name,
            fileSize: file.size,
          });
          this.dataService.updateProgressBarSubject(false);
        },
        error: (err) => {
          if (err.status == 400) {
            this.dialogService.openMessageDialog(
              "Error",
              "File already exists, please try uploading a different file.",
            );
          } else {
            this.dialogService.openMessageDialog(
              "Error",
              "File Size Limit Exceeded.",
            );
          }
        },
      });
  }

  @HostListener("drop", ["$event"])
  onDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    Array.from(e.dataTransfer?.files ?? []).forEach((f) =>
      this.fileUploadService.uploadWithProgress(
        f,
        "confirm",
        this.taskId,
        this.fileDetailsScan,
        f.name,
        (name) => this.removeFileByName(name),
      ),
    );
    e.dataTransfer?.clearData();
  }

  uploadedFiles: any[] = [];

  keepOrder = (_a: KeyValue<string, number>, _b: KeyValue<string, number>) => 0;
  trackByFileName = (_: number, f: { fileName: string }) => f.fileName;

  orignialFileNameForUpload: string = "";

  async addFileDetails(ev: Event) {
    const input = ev.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    const MAX_SIZE_BYTES = 200 * 1024 * 1024;
    files.forEach((file) => {
      if (file.size > MAX_SIZE_BYTES) {
        this.dialogService.openMessageDialog(
          "File Too Large",
          `The file "${file.name}" is ${this.fileUploadService.formatBytes(file.size)}. Please upload files smaller than 200MB.`,
        );
        return;
      }
      if (file.name.toLowerCase().endsWith(".xml")) {
        this.parseDentalXml(file);
      }
      let displayName = file.name;
      let counter = 1;
      this.orignialFileNameForUpload = file.name;
      const nameExists = () =>
        this.fileDetailsScan.some((f) => f.fileName === displayName);
      while (nameExists()) {
        const dotIndex = file.name.lastIndexOf(".");
        const baseName =
          dotIndex !== -1 ? file.name.substring(0, dotIndex) : file.name;
        const extension = dotIndex !== -1 ? file.name.substring(dotIndex) : "";
        displayName = `${baseName} (${counter})${extension}`;
        counter++;
      }
      this.fileDetailsScan.push({
        fileName: displayName,
        fileSize: file.size,
        fileType: file.type,
        fileId: 0,
      } as any);
      const renamedFile = new File(
        [file.slice(0, file.size, file.type)],
        displayName,
        { type: file.type },
      );
      this.fileUploadService.uploadWithProgress(
        renamedFile,
        "confirm",
        this.taskId,
        this.fileDetailsScan,
        file.name,
        (name) => this.removeFileByName(name),
      );
    });
    input.value = "";
  }

  isXmlUpload: boolean = false;

  async parseDentalXml(file: File): Promise<void> {
    //console.log('========== XML Upload Started ==========');
    //console.log('Selected File:', file);

    this.isXmlUpload = true;
    console.log('isXmlUpload:', this.isXmlUpload);

    this.dentalXmlService
      .parse(
        file,
        this.teethList,
        this.dataService.anteriorTeeth,
        this.types
      )
      .then(result => {

        //console.log('Original XML Result:', result);

        // ===========================
        // Convert Universal -> FDI
        // ===========================

        result.toothData = result.toothData.map((item: any) => ({
          ...item,
          teeth: this.universalToFDI(item.teeth)
        }));

        result.allToothIds = result.allToothIds.map((id: number) =>
          this.universalToFDI(id)
        );

        result.bridges = result.bridges.map((bridge: any) => ({
          ...bridge,
          start: this.universalToFDI(bridge.start),
          end: this.universalToFDI(bridge.end),
          bridgedTeeth: bridge.bridgedTeeth.map((id: number) =>
            this.universalToFDI(id)
          )
        }));

        //console.log('Converted XML Result:', result);

        this.teethType = result.detectedType;
        //console.log('Detected Teeth Type:', this.teethType);

        this.orderDetailsNew = {
          ...this.orderDetailsNew,
          refNum: result.refNum,
          instructions: result.instructions,
          toothData: result.toothData,
          bridges: result.bridges,
          props: {
            ...this.orderDetailsNew.props,
            ...result.bridgeProps
          }
        };

        //console.log('Updated orderDetailsNew:', this.orderDetailsNew);

        this.defaultSelectedMaterialValue = result.matValueName;
        //console.log('Default Selected Material:', this.defaultSelectedMaterialValue);

        this.selectedTeethSet = new Set(result.allToothIds);
        //console.log('Selected Teeth Set:', [...this.selectedTeethSet]);

        //console.log('Calling getPropsFromBackend()');
        this.getPropsFromBackend();

        //console.log('Calling refreshPropsForXmlUpload()');
        this.refreshPropsForXmlUpload();

        //console.log('Calling setDefaultMaterialForUploadXmlFile()');
        this.setDefaultMaterialForUploadXmlFile(result.matValueName);

        //console.log('Calling refreshBridges()');
       // this.refreshBridges();

        //console.log('Running detectChanges()');
        this.cdr.detectChanges();

        //console.log('========== XML Upload Completed ==========');

      })
      .catch(error => {
        console.error('XML Parse Error:', error);
      });

    console.log('Calling refreshAvailableTypes()');
    this.refreshAvailableTypes();

    console.log('parseDentalXml() method execution finished.');
  }private universalToFDI(tooth: number): number {
    const map: Record<number, number> = {
      1: 18, 2: 17, 3: 16, 4: 15, 5: 14, 6: 13, 7: 12, 8: 11,
      9: 21, 10: 22, 11: 23, 12: 24, 13: 25, 14: 26, 15: 27, 16: 28,

      17: 38, 18: 37, 19: 36, 20: 35, 21: 34, 22: 33, 23: 32, 24: 31,

      25: 48, 26: 47, 27: 46, 28: 45, 29: 44, 30: 43, 31: 42, 32: 41
    };

    return map[tooth] ?? tooth;
  }

  createNewToothObject(tNum: number, type: string, subType: string, connection: string, material: string) {
    return this.dentalXmlService.createNewToothObject(tNum, type, subType, connection, material);
  }
  expandRangeToToothData(start: number, end: number) {
    const startIndex = this.teethList.indexOf(start);
    const endIndex = this.teethList.indexOf(end);

    if (startIndex === -1 || endIndex === -1) return;

    const low = Math.min(startIndex, endIndex);
    const high = Math.max(startIndex, endIndex);

    // Loop through every tooth found in the range in your master list
    for (let i = low; i <= high; i++) {
      this.updateToothInArray(this.teethList[i], true);
    }
  }
  buildOrderProps(toothData: any[]) {
    return this.dentalXmlService.buildOrderProps(toothData);
  }
  updateToothInArray(toothId: number, isBridge: boolean = false) {
    let tooth: ToothDataNew | undefined = this.orderDetailsNew.toothData.find(
      (d) => d.teeth === toothId,
    );

    if (!tooth) {
      // 2. If it doesn't exist, create it and push it
      const newTooth: ToothDataNew = {
        teeth: toothId,
        selected: true,
        bridgeConnectionType: isBridge ? "Bridge" : "",
        type: isBridge ? "Anatomy" : "Crown",
        // ... add other required properties here
        id: 0,
        subType: "",
        minimalThickness: 0,
        cementGap: 0,
        marginGap: 0,
        horizontalBorder: 0,
        radiusCompensation: 0,
        props: {},
      };
      this.orderDetailsNew.toothData.push(newTooth);
    } else {
      // 3. If it does exist, TypeScript now knows it is NOT undefined here
      tooth.selected = true;
      if (isBridge) tooth.bridgeConnectionType = "Bridge";
    }
  }

  trackByTempId(index: number, item: any) {
    return item.tempId;
  }

  removeFileByName(fileName: string) {
    this.dataService.updateProgressBarSubject(true);
    this.dataService
      .delete(
        "/tasks/" +
          this.taskId +
          "/files?file-name=" +
          fileName.replace(/[^a-zA-Z0-9.]/g, "_"),
      )
      .subscribe({
        next: (response) => {
          var index = this.fileDetailsScan.findIndex(
            (file) => file.fileName === fileName,
          );
          if (index > -1) {
            this.fileDetailsScan.splice(index, 1);
          }
          this.dataService.updateProgressBarSubject(false);
        },
        error: (err) => {
          this.dialogService.handleError(
            err,
            "Failed to Remove File, Please try again.",
          );
        },
      });
  }

  articulationErrMsg: string | null = null;

  validateArticulatorRange() {
    var q2Value =
      this.orderDetailsNew.articulationDetails.props[
        "Raising or lowering the articulator"
      ];
    this.articulationErrMsg = null;

    if (isNaN(q2Value)) {
      this.articulationErrMsg = "Invalid Value";
    }

    if (q2Value < -50.0 || q2Value > 50.0) {
      this.articulationErrMsg =
        "Value out of range, should be between -50 mm to +50 mm";
    }

    const incrementValid = (q2Value * 100) % 1 === 0;
    if (!incrementValid) {
      this.articulationErrMsg =
        "Invalid value, should be in increments of 0.01 mm";
    }
  }

  protrusionAngleRange: any = {
    "Artex von Amann Girrbach": [
      15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32,
      33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50,
      51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
    ],
    SAM: [
      20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
      38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55,
      56, 57, 58, 59, 60,
    ],
    "KaVo PROTAR evo": [
      10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
      28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
      46, 47, 48, 49, 50,
    ],
    "Whip Mix DENAR Mark 330": [
      10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27,
      28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45,
      46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60,
    ],
  };

  bennettAngleRange: any = {
    "Artex von Amann Girrbach": [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
    SAM: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25,
    ],
    "KaVo PROTAR evo": [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
    "Whip Mix DENAR Mark 330": [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
      21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
    ],
  };

  issRange: any = {
    "Artex von Amann Girrbach": [
      0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4,
      1.5, 1.6, 1.7, 1.8, 1.9, 2,
    ],
    SAM: [
      0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4,
      1.5, 1.6, 1.7, 1.8, 1.9, 2,
    ],
    "KaVo PROTAR evo": [
      0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4,
      1.5, 1.6, 1.7, 1.8, 1.9, 2, 2.1, 2.2, 2.3, 2.4, 2.5, 2.6, 2.7, 2.8, 2.9,
      3,
    ],
    "Whip Mix DENAR Mark 330": [
      0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1, 1.1, 1.2, 1.3, 1.4,
      1.5, 1.6, 1.7, 1.8, 1.9, 2, 2.1, 2.2, 2.3, 2.4, 2.5,
    ],
  };

  incisalGuidanceRange: any = {
    "Artex von Amann Girrbach": [
      5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25, 26, 27, 28, 29, 30,
    ],
    SAM: [
      5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25,
    ],
    "KaVo PROTAR evo": [
      5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
      25,
    ],
    "Whip Mix DENAR Mark 330": [
      5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    ],
  };

  biteTypes: string[] = [
    "normal-bite",
    "overbite",
    "underbite",
    "excessive-spacing",
    "deep-bite",
    "crossbite",
    "crowding",
    "open-bite",
  ];

  changeBiteType(biteType: string): void {
    this.orderDetailsNew.biteType = biteType;
    this.showSlider.value = false;
  }

  get calculateAmountOnTimeAndTier(): number {
    let amount = 0.0;

    if (this.orderDetailsNew.showAi) {
      if (this.orderDetailsNew.deliveryTime == "10") {
        amount = 3.87;
      }

      if (this.orderDetailsNew.deliveryTime == "4") {
        amount = 4.78;
      }
    }

    if (this.orderDetailsNew.tier == "silver") {
      amount = 6.99;
    }

    if (this.orderDetailsNew.tier == "gold") {
      amount = 12.99;
      if (this.orderDetailsNew.deliveryTime === "12") {
        amount += 2.99;
      }
    }

    if (this.orderDetailsNew.tier == "platinum") {
      amount = 31.99;
      if (this.orderDetailsNew.deliveryTime === "12") {
        amount += 2.99;
      }
      if (this.orderDetailsNew.deliveryTime === "8") {
        amount += 4.99;
      }
    }

    return amount * this.orderDetailsNew.toothData.length; // Multiply by number of teeth selected
  }

  get isAbutmentSelected(): boolean {
    if (this.orderDetailsNew.toothData.length > 0) {
      const firstSelected = this.orderDetailsNew.toothData.find(
        (data) => data.selected,
      );
      return firstSelected?.type === "Abutment";
    }
    return false;
  }
  // abutment-gingival
  onAbutmentStep1Change(value: string) {
    setTimeout(() => {
      const abutmentStep1 = this.abutmentStep1?.nativeElement; // Replace with your accordion item's ID
      const abutmentStep2 = this.abutmentStep2?.nativeElement; // Replace with your accordion item's ID
      this.abutmentStep1Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep1, {
            toggle: false,
          })
        : undefined;
      this.abutmentStep2Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep2, {
            toggle: false,
          })
        : undefined;

      this.abutmentStep1Instance?.hide();
      this.abutmentStep2Instance?.show();
    });
  }

  onAbutmentStep2Change(value: string) {
    setTimeout(() => {
      const abutmentStep2 = this.abutmentStep2?.nativeElement; // Replace with your accordion item's ID
      const abutmentStep3 = this.abutmentStep3?.nativeElement; // Replace with your accordion item's ID

      this.abutmentStep2Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep2, {
            toggle: false,
          })
        : undefined;

      this.abutmentStep3Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep3, {
            toggle: false,
          })
        : undefined;

      this.abutmentStep2Instance?.hide();
      this.abutmentStep3Instance?.show();
    });
  }
  onAbutmentStep3Change(value: string) {
    setTimeout(() => {
      const abutmentStep3 = this.abutmentStep3?.nativeElement; // Replace with your accordion item's ID
      const abutmentStep4 = this.abutmentStep4?.nativeElement; // Replace with your accordion item's ID

      this.abutmentStep3Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep3, {
            toggle: false,
          })
        : undefined;

      this.abutmentStep4Instance = bootstrap?.Collapse?.getOrCreateInstance
        ? bootstrap.Collapse.getOrCreateInstance(abutmentStep4, {
            toggle: false,
          })
        : undefined;

      this.abutmentStep3Instance?.hide();
      this.abutmentStep4Instance?.show();
    });
  }
  onAbutmentStep4Change(value: string) {
    // setTimeout(() => {
    //     const abutmentStep3 = this.abutmentStep3?.nativeElement; // Replace with your accordion item's ID
    //     const abutmentStep4 = this.abutmentStep4?.nativeElement; // Replace with your accordion item's ID
    //     this.abutmentStep3Instance = bootstrap?.Collapse?.getOrCreateInstance
    //     ? bootstrap.Collapse.getOrCreateInstance(abutmentStep3, { toggle: false })
    //     : undefined;
    //     this.abutmentStep4Instance = bootstrap?.Collapse?.getOrCreateInstance
    //     ? bootstrap.Collapse.getOrCreateInstance(abutmentStep4, { toggle: false })
    //     : undefined;
    //     this.abutmentStep3Instance?.hide();
    //     this.abutmentStep4Instance?.show();
    //   })
  }

  getAbutmentSelectedTooth() {
    return this.abutmentSelectedTooth;
  }
  showAddMaterialPopup: boolean = false;

  selectedBiteType: string = "normal-bite";
  getLastTaskData() {
    this.dataService.get(`/tasks/second-last`).subscribe({
      next: (response) => {
        this.articulation = response.articulator;
        this.software = response.software;
        this.byteType = response.biteType;

        if (response && response.biteType) {
          if (this.byteType == "normal bite") {
            response.biteType = "normal-bite";
          }
          this.selectedBiteType = response.biteType;
        } else {
          this.selectedBiteType = "normal-bite";
        }
        if (response && response.software) {
          this.orderDetailsNew.software = response.software;
        } else {
          this.orderDetailsNew.software = "";
        }
        if (response && response.articulator) {
          this.orderDetailsNew.articulationDetails.articulator =
            response.articulator;
        } else {
          this.orderDetailsNew.articulationDetails.articulator =
            "Artex von Amann Girrbach";
        }
        if (response && response.ProtrusionAngle) {
          this.orderDetailsNew.articulationDetails.props["Protrusion Angle"] =
            response.ProtrusionAngle;
        } else {
          this.orderDetailsNew.articulationDetails.props["Protrusion Angle"] =
            "30";
        }
        if (response && response.BennettAngle) {
          this.orderDetailsNew.articulationDetails.props["Bennett Angle"] =
            response.BennettAngle;
        } else {
          this.orderDetailsNew.articulationDetails.props["Bennett Angle"] =
            "15";
        }
        if (response && response.ImmediateSideShif) {
          this.orderDetailsNew.articulationDetails.props[
            "Immediate Side Shift (ISS)"
          ] = response.ImmediateSideShif;
        } else {
          this.orderDetailsNew.articulationDetails.props[
            "Immediate Side Shift (ISS)"
          ] = "0.5";
        }
        if (response && response.IncisalGuidance) {
          this.orderDetailsNew.articulationDetails.props["Incisal Guidance"] =
            response.IncisalGuidance;
        } else {
          this.orderDetailsNew.articulationDetails.props["Incisal Guidance"] =
            "10";
        }
        if (response && response.RaisingOrLoweringTheArticulator) {
          this.orderDetailsNew.articulationDetails.props[
            "Raising or lowering the articulator"
          ] = response.RaisingOrLoweringTheArticulator;
        } else {
          this.orderDetailsNew.articulationDetails.props[
            "Raising or lowering the articulator"
          ] = "-0.2";
        }
      },
      error: () => {
        this.selectedBiteType = "normal-bite";
      },
    });
  }

  get submittedTeeth(): number[] {
    return this.abutmentService.submittedTeeth;
  }
  set submittedTeeth(v: number[]) {
    this.abutmentService.submittedTeeth = v;
  }

  validateAndProceed(): void {
    this.abutmentService.validateAndProceed(this.orderDetailsNew.toothData);
  }

  openAddNewMaterial(event: Event) {
    event.stopPropagation();
    if (this.materialService.newMaterial.trim()) {
      this.materialService.materialList.push(
        this.materialService.newMaterial.trim(),
      );
      this.materialService.newMaterial = "";
    }
    this.openDialog();
  }

  @ViewChildren("editInput") editInputs!: QueryList<ElementRef>;

  removeMaterial(index: number) {
    this.materialService.removeMaterial(
      index,
      this.teethType,
      (props) => {
        this.props = props;
      },
      () => this.refreshProps(),
    );
  }

  startEdit(index: number, item: any) {
    this.materialService.startEdit(index, item, this.teethType);
  }

  addTempParam() {
    this.materialService.addTempParam();
  }
  removeTempParam(index: number) {
    this.materialService.removeTempParam(index);
  }

  saveEdit(index: number, valueFromInput: string) {
    this.materialService.saveEdit(
      index,
      valueFromInput,
      this.currentProps,
      this.teethType,
      (props) => {
        this.props = props;
      },
      () => this.refreshProps(),
    );
  }

  filterOptions(index: number) {
    this.materialService.filterOptions(index);
  }
  selectOption(value: string, index: number) {
    this.materialService.selectOption(value, index);
  }
  hideDropdown(index: number) {
    this.materialService.hideDropdown(index);
  }
  addEditParam(index: number) {
    this.materialService.addEditParam(index);
  }
  removeEditParam(rowIndex: number, paramIndex: number) {
    this.materialService.removeEditParam(rowIndex, paramIndex);
  }

  setDefaultMaterial() {
    this.materialService.setDefaultMaterial(
      this.currentProps,
      this.orderDetailsNew.toothData,
      this.teethType,
      (val) => {
        this.previousMaterialValue = val;
      },
    );
  }

  setDefaultMaterialForUploadXmlFile(extractedValue: string) {
    this.materialService.setDefaultMaterialForUploadXmlFile(
      extractedValue,
      this.currentProps,
      this.orderDetailsNew.toothData,
      this.teethType,
      (val) => {
        this.previousMaterialValue = val;
      },
    );
  }

  selectEditOption(value: string, param: any) {
    this.materialService.selectEditOption(value, param);
  }
  hideEditDropdown(param: any) {
    this.materialService.hideEditDropdown(param);
  }
  openDropdown(i: number, j: number) {
    this.materialService.openDropdown(i, j);
  }
  openDropdownEdit(i: number, j: number) {
    this.materialService.openDropdownEdit(i, j);
  }
  filterOptionsEdit(i: number, j: number) {
    this.materialService.filterOptionsEdit(i, j);
  }
  selectOptionEdit(option: string, i: number, j: number) {
    this.materialService.selectOptionEdit(option, i, j);
  }
  hideDropdownEdit(i: number, j: number) {
    this.materialService.hideDropdownEdit(i, j);
  }
  formatParamName(name: string): string {
    return this.materialService.formatParamName(name);
  }

  formatFileSize(bytes: number): string {
    if (bytes === null || bytes === undefined || isNaN(bytes)) return "";
    const MB = 1048576;
    const KB = 1024;
    return bytes >= MB
      ? `${(bytes / MB).toFixed(2)} MB`
      : `${(bytes / KB).toFixed(2)} KB`;
  }

  startPolling() {
    this.uploadPolling?.unsubscribe();
    this.uploadPolling = interval(5000).subscribe(() => {
      this.dataService
        .get(`/tasks/${this.taskId}/files`, {})
        .subscribe((files: any[]) => {
          files.forEach((file) => {
            if (!this.fileUploadService.progress[file.fileName]) {
              this.fileUploadService.initProgressForExistingFile(
                file.fileName,
                file.fileSize,
              );
            }
          });
        });
    });
  }

  generateQRCode() {
    this.dataService
      .post("/upload/create-session", {
        taskId: this.taskId,
        userId: this.dataService.userId,
      })
      .subscribe({
        next: (response: any) => {
          this.qrCodeUrl = `${response.qrUrl}&taskId=${response.taskId}`;
          this.showQRCode = true;
          this.uploadToken = response.token;
          this.startPolling();
        },
        error: (err) => {
          console.error(err);
        },
      });
  }
}
